<template>
  <div>
    <!-- <h1>run_with_results</h1> -->
    <section>
      <p>Voici les décisions suggérées en fonction des données d'entrée que vous avez saisies ci-dessus. Vous pouvez cliquer sur le symbole <v-icon>mdi-chevron-down</v-icon> pour obtenir la trace du raisonnement et l'explication de chaque décision.</p>
      <p v-if="isAdvancedMode">Si vous n'obtenez aucune solution, vous devez vérifier la représentation de vos options et scénarios en langage <a href="https://www.swi-prolog.org">PROLOG</a>, si vous avez effectué une traduction personnalisée à partir du langage naturel (par exemple, cohérence des noms de variables dans les options et scénarios, etc.)</p>
    </section>
  </div>
</template>
<script>
export default {
  computed: {
    isAdvancedMode () {
      return this.$store.state.mode === 'advanced'
    },
  },
}
</script>